export const algebraKeysProps = [
  {
    id: '=',
    label: '=',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '=',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: 'approx',
    label: '\\approx',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\approx',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: '≤',
    label: '\\leq',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\leq',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: '≥',
    label: '\\geq',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\geq',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: '<',
    label: '<',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '<',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: '>',
    label: '>',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '>',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: '±',
    label: '\\pm',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\pm',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: '&#8730',
    label: '\\sqrt{}',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\sqrt{}',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: 's5',
    label: '\\^{\\circ}',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\^{\\circ}',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: 's3',
    label: '\\frac{}{}',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\frac{}{}',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    id: 's4',
    label: '\\mfrac{}{}{}',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\mfrac{}{}{}',
      method: 'write',
    },
    group: 'algebra',
  },
  {
    // new addition started here
    id: 's1',
    label: '\\^{}',
    labelType: 'tex',
    group: 'basicOperations',

    mathfieldInstructions: { content: '\\^{}', method: 'write' },
  },
  {
    id: 's2',
    label: '\\_{}',
    labelType: 'tex',
    group: 'otherOperations',

    mathfieldInstructions: {
      content: '\\_{}',
      method: 'write',
    },
  },
]
